<template>
    <div class="form__date">
        <div>
            <label :for="`${compId}-date`" class="form__label">{{ label + 'datum' }}</label>
            <VueDatePicker
                :input-attrs="{
                    id:`${compId}-date`
                }"
                :model-value="dateModel"
                @update:model-value="$emit('update:dateModel', $event)"
                v-bind="$attrs"
                locale="de"
                selectText="Auswählen"
                cancelText="Abbrechen"
                format="dd.MM.yyyy"
                :disabled-dates="disabledDates"
                :min-date="minDate"
                :enable-time-picker="false"
                auto-apply
                :class="{'has-error': error}"
            >
                <template #day="{ date, day }">
                    <span class="form__calendar-day" :title="closedDayReason(date) || undefined">{{ day }}</span>
                </template>
            </VueDatePicker>
        </div>
        <div>
            <label :for="`${compId}-time`" class="form__label">{{ label + 'zeit'}}</label>
            <select
                :id="`${compId}-time`"
                v-if="timeOptions.length > 0"
                :value="timeModel"
                class="form__select"
                :class="{'has-error': error}"
                @change="$emit('update:timeModel', $event.target.value)"
            >
                <option value="" disabled>Zeit wählen</option>
                <option v-for="t in timeOptions" :key="t" :value="t">{{ t }}</option>
            </select>
            <div v-else>
                Bitte wählen Sie ein Datum aus!
            </div>
        </div>
        <p
            v-if="error"
            :id="`${compId}-error`"
            class="form__error"
            aria-live="assertive"
        >
            {{ error }}
        </p>
    </div>
</template>

<script setup>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { useId } from 'vue'

const compId = 'field-' + useId()
defineProps({
    label: String,
    dateModel: Date,
    timeModel: String,
    timeOptions: Array,
    disabledDates: Function,
    closedDayReason: {
        type: Function,
        default: () => ''
    },
    minDate: Date,
    error: {
        type: String,
        default: ''
    }
});

defineEmits(['update:dateModel', 'update:timeModel']);

</script>

<style scoped>
.form__calendar-day {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}
</style>
